// extracted by mini-css-extract-plugin
export var Marquee = "sGvWa";
export var MarqueeText = "hxWYR";
export var aMarquee = "_6ionD";